import { Atom } from "AppReact";
import styled, { css } from "styled-components";

const template = styled.video`
  ${({ displayState }) => css`
    width: ${displayState?.width ?? '34px'};
    height: ${displayState?.height ?? '34px'};
    border-radius: 8px;
    border: 1px solid #E3E3E3;
    object-fit: cover;
    background: ${displayState?.displayBackground ? `url('/images/loadingVideo.gif')` : ''};
    background-size:100%;
  `}
`;

export default Atom({ type: 'image', dataType: 'string', template });
